import { injectGlobal, CSSObject } from '@emotion/css';
import { pxToRem } from '../utils';
import Config from '../../../system-utils/config-manager';
import { defaultLinkStyle } from '../components/links';

const baseListStyle: CSSObject = {
  fontSize: 'inherit',
  lineHeight: 'inherit',
  margin: 0,
  padding: 0,
  paddingBottom: pxToRem(32),
};

const featureListStyle: CSSObject = {
  fontSize: pxToRem(18),
  lineHeight: pxToRem(28),

  li: {
    borderColor: 'var(--color-border)',
    borderStyle: 'solid',
    borderWidth: 0,
    borderBottomWidth: '1px',
    fontWeight: 'var(--font-weight-regular)',
    marginBottom: pxToRem(32),
    paddingLeft: 0,

    '&::before': {
      content: '""',
    },

    '& strong': {
      fontWeight: 'var(--font-weight-medium)',
    },
  },

  'li:first-child': {
    borderTopWidth: '1px',
    paddingTop: pxToRem(32),
  },
};

// We must wait for the config to be parsed before trying to get a value from it.
const tickListStyle = (): CSSObject => ({
  li: {
    paddingLeft: pxToRem(32),

    '&:before': {
      backgroundImage: `url(${Config.get('image_cdn_base_url')}/ui/shared-component-webapp/lists/tick-red.svg)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: pxToRem(24),
      content: '""',
      width: pxToRem(24),
      height: pxToRem(24),
    },
  },

  '&.tick-black': {
    'li:before': {
      backgroundImage: `url(${Config.get('image_cdn_base_url')}/ui/shared-component-webapp/lists/tick-black.svg)`,
    },
  },
  '&.tick-lime': {
    'li:before': {
      backgroundImage: `url(${Config.get('image_cdn_base_url')}/ui/shared-component-webapp/lists/tick-lime.svg)`,
    },
  },
});

const collapsedListStyle: CSSObject = {
  li: {
    paddingBottom: 0,
  },
};

const unstyledListStyle: CSSObject = {
  li: {
    paddingBottom: 0,
    paddingLeft: 0,

    '&::before': {
      content: '""',
    },
  },
};

// We must wait for the config to be parsed before trying to get a value from it.
const downloadsListStyle = (): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  listStyle: 'none',

  '& li': {
    borderBottom: '1px solid var(--color-border)',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: pxToRem(16),
    paddingBottom: pxToRem(16),
    paddingLeft: pxToRem(36),

    '&::before': {
      content: '""',
    },

    '& a': {
      ...defaultLinkStyle,
      display: 'flex',
      flexDirection: 'row',
      fontFamily: 'var(--font-heading)',
      fontWeight: 'var(--font-weight-medium)',
      marginLeft: pxToRem(-36),

      '&:before': {
        backgroundColor: 'currentColor',
        content: '""',
        maskImage: `url(${Config.get('image_cdn_base_url')}/ui/shared-component-webapp/shared/download.svg)`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        paddingRight: pxToRem(12),
        width: pxToRem(24),
        height: pxToRem(24),
      },
    },

    // Keeping since this is used in html terms, prefer small instead of span
    '& span': {
      color: 'var(--color-muted)',
      fontSize: pxToRem(14),
      fontWeight: `var(--font-weight-light)`,
      marginTop: pxToRem(4),
    },

    '& small': {
      color: 'var(--color-muted)',
      fontSize: pxToRem(14),
      fontWeight: `var(--font-weight-light)`,
      marginTop: pxToRem(4),
    },
  },
});

Config.onReady(() => {
  injectGlobal({
    ul: {
      ...baseListStyle,
      listStyle: 'none',

      li: {
        paddingLeft: pxToRem(32),
        paddingBottom: pxToRem(32),
        position: 'relative',

        '&::before': {
          content: '"•"',
          display: 'inline-block',
          position: 'absolute',
          left: 0,
        },
      },
    },
    'ul ul': {
      listStyle: 'none',
      paddingTop: pxToRem(32),
      paddingBottom: 0,

      '& li:last-child': {
        paddingBottom: 0,
      },

      '& li::before': {
        opacity: 0.5,
      },
    },
    'ul.feature': featureListStyle,
    'ul.tick': tickListStyle(),
    'ul.collapsed': collapsedListStyle,
    'ul.unstyled': unstyledListStyle,
    'ul.documents': downloadsListStyle(), // Keeping since this is used in html terms, prefer downloads instead
    'ul.downloads': downloadsListStyle(),
  });
});
